<template>
  <div class="mb-60">
    <div class="bg-green py-60 px-20 mb-40">
      <h2 class="font-[700] text-40 !text-white text-center mb-20">Find your local BDM</h2>
      <div class="">
        <PulseLoader :loading="loader.loading" :color="loader.color" :size="loader.size"></PulseLoader>
      </div>
      <SearchForm v-show="!loader.loading" @processForm="processForm" />
    </div>
    <h2 v-show="product && !isDisallowed" class="text-left text-blue text-40 font-bold">{{ searchMessage }}</h2>
    <p v-show="isDisallowed" class="text-left text-20">{{ disallowedMessage }}</p>

    <SearchResults v-if="bdms.length > 0" :bdms="bdms" />
  </div>
</template>

<script>
//libraries
import axios from 'axios';
import queryString from 'query-string';

//components
import SearchForm from './SearchForm.vue';
import SearchResults from './SearchResults.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  components: {
    SearchForm,
    SearchResults,
    PulseLoader,
  },
  data() {
    return {
      ajaxurl: ajaxurl, // Set globally by WordPress
      bdmData: [],
      regionData: [],
      bdms: [],
      regions: [],
      product: '',
      isDisallowed: false,
      disallowedData: [],
      disallowedMessage: '',
      loader: {
        loading: true,
        color: '#EE7E28',
        size: '7px',
      },
    };
  },

  computed: {
    searchMessage() {
      return this.bdms.length === 0 ? 'No BDMs found.' : 'BDMs matching your search...';
    },
  },

  methods: {
    async getRegionData() {
      try {
        const res = await axios.post(
          this.ajaxurl,
          { action: 'get_regions' },
          {
            transformRequest: [
              function (data) {
                data = queryString.stringify(data);
                return data;
              },
            ],
          }
        );

        this.regionData = res.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getBdmData() {
      try {
        const res = await axios.post(
          this.ajaxurl,
          { action: 'get_bdms' },
          {
            transformRequest: [
              function (data) {
                data = queryString.stringify(data);
                return data;
              },
            ],
          }
        );
        this.bdmData = res.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getDisallowedData() {
      try {
        const res = await axios.post(
          this.ajaxurl,
          { action: 'get_disallowed_postcodes' },
          {
            transformRequest: [
              function (data) {
                data = queryString.stringify(data);
                return data;
              },
            ],
          }
        );

        this.disallowedData = res.data;
        this.loader.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    getRegion(postcode) {
      const postcodePrefix = this.getPostcodePrefix(postcode);

      this.isPostcodeDisallowed(postcodePrefix);

      this.regions = this.regionData.filter((region) => {
        const postcodesArr = region.postcodes.replace(/\s/g, '').split(',');
        return postcodesArr.includes(postcodePrefix);
      });

      this.regions.length !== 0 ? this.getBdms(this.regions) : this.reset();
    },

    getBdms(regions) {

      let bdmsArr = [];

      bdmsArr = this.bdmData.filter(bdmObj => {
        return regions.some(regionObj => bdmObj.regions.includes(regionObj.region));
      });

      if (this.product !== 'All') {
        bdmsArr = bdmsArr.filter((val) => val.product.includes(this.product));
      }

      this.bdms = bdmsArr;
    },

    getPostcodePrefix(postcode) {
      const firstTwoChars = postcode.substr(0, 2); // Get first two characters
      return firstTwoChars.replace(/\d+/g, '').toUpperCase(); // Remove numbers
    },

    processForm(postcode, product) {
      this.reset();
      const postcodeRegex = /^([A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] 0[Aa]{2})$/;
      const isValidPostcode = postcodeRegex.test(postcode);
      this.product = product;
      isValidPostcode ? this.getRegion(postcode) : alert('Please input a valid UK postcode.');
    },

    isPostcodeDisallowed(postcode) {
      let tempArr = this.disallowedData.find((data) => {
        const postcodesArr = data.postcodes.replace(/\s/g, '').split(',');
        return postcodesArr.includes(postcode);
      });

      if (tempArr) {
        this.disallowedMessage = tempArr.message;
        return (this.isDisallowed = true);
      }
    },

    reset() {
      this.bdms = [];
      this.isDisallowed = false;
    },
  },

  async created() {
    this.getBdmData();
    this.getRegionData();
    this.getDisallowedData();
  },
};
</script>
